module.exports = __webpack_public_path__ + "img/ddedit.a1c774f7.svg";